import React, { ReactNode } from 'react';
import { StopwatchProvider } from './StopwatchContext';

/**
 * Props for the AppProvider component
 */
interface AppProviderProps {
  children: ReactNode;
}

/**
 * Root provider that combines all context providers
 * @param props - Component props
 * @returns Provider component
 */
const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  return <StopwatchProvider>{children}</StopwatchProvider>;
};

export default AppProvider;
